export default __webpack_public_path__ + "static/media/transaction.2008d05c.png";